import { api } from "../utils/api";
import type {
  RestBookkeepingAccount,
  RestCreateBookkeepingAccount,
  RestUpdateBookkeepingAccount,
} from "@KassaroAB/shared/types/bookkeepingAccount";
import type { BookkeepingAccountId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  catalogParentPath,
  type CatalogScope,
} from "./catalogScope";

const bookkeepingAccountsPath = (scope: CatalogScope) =>
  scope.type === "store"
    ? `${catalogParentPath(scope)}/bookkeeping/accounts`
    : catalogCollectionPath(scope, "bookkeepingAccounts");

export const getBookkeepingAccountsApi = (
  scope: CatalogScope,
): Promise<RestBookkeepingAccount[]> => {
  return api.get(bookkeepingAccountsPath(scope));
};

export const getBookkeepingAccountApi = (
  scope: CatalogScope,
  accountId: BookkeepingAccountId,
): Promise<RestBookkeepingAccount> => {
  return api.get(`${bookkeepingAccountsPath(scope)}/${accountId}`);
};

export const createBookkeepingAccountApi = (
  scope: CatalogScope,
  account: RestCreateBookkeepingAccount,
): Promise<RestBookkeepingAccount> => {
  return api.post(bookkeepingAccountsPath(scope), account);
};

export const updateBookkeepingAccountApi = (
  scope: CatalogScope,
  accountId: BookkeepingAccountId,
  account: RestUpdateBookkeepingAccount,
): Promise<RestBookkeepingAccount> => {
  return api.put(`${bookkeepingAccountsPath(scope)}/${accountId}`, account);
};

export const deleteBookkeepingAccountApi = (
  scope: CatalogScope,
  accountId: BookkeepingAccountId,
): Promise<void> => {
  return api.delete(`${bookkeepingAccountsPath(scope)}/${accountId}`);
};
